import { Subject } from 'rxjs/Subject';

export class WarningModalActions {
    allowNavigate?: Subject<boolean>;
    keepWorking?(): void;
    discard?(): void;
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/unsaved.warning.modal/warning.modal.actions.ts